import React, { useEffect, useState } from 'react'
import InputSelect from '../shared/input/new/InputSelect';
import InputText from '../shared/input/new/InputText';
import Btn from '../shared/button/Btn';
import { showModal } from '../../features/modal/modalSlice';
import { createCompaniesProject, setIsSearchCompany, setSearchCompany } from '../../features/isOrtaklari/isOrtaklariSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import SmallSpinner from '../shared/spinners/SmallSpinner';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  .project-info{
    p{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
    }
  }
  .btn-container{
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: center;
  }
`

const MatchNewProject = () => {
  const dispatch = useDispatch()
  const { searchCompany, getIsLoading } = useSelector(state => state.isOrtaklari)
  const [isSubmit, setIsSubmit] = useState(false)
  const [kayitData, setKayitData] = useState({
      vergiNo:"",
      projectName: "",
      companyName: searchCompany?.companyName
  })

  useEffect(() => {
    setKayitData((prev) => ({...prev, vergiNo: searchCompany?.companyTaxNo}))
  }, [searchCompany])

  const handleChange = ({e, type}) => {
    if(type === "number"){
        setKayitData((prev) => ({...prev, [e.target.name]: e.target.value.replace(/[^0-9]/g, '')}))
    }
    else{
        setKayitData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }
  }

  const handleSubmit = () => {
    setIsSubmit(true)
    if(kayitData?.vergiNo, kayitData?.projectName){
        const addData = {
            vergiNo: kayitData?.vergiNo,
            projectName: kayitData?.projectName
        }
        
        dispatch(createCompaniesProject(addData))
    }
  }

  return (
    <Container>
      <div className="project-info">
        <p>Proje oluşturmak istediğiniz firma kayıtlıdır. Tarafların anlayabileceği bir isim vererek proje oluşturunuz.</p>
      </div>

      <div className="input-grp">
          <InputText disabled={searchCompany} data={kayitData.companyName} setData={(e) => handleChange({e, type: ""})} labelText="Firma Adı" inputWidth={"100%"} name={"companyName"}/>
      </div>
      
      <div className="input-grp">
          <InputText data={kayitData.projectName} setData={(e) => handleChange({e, type: ""})} labelText="Proje İsmi" inputWidth={"100%"} name={"projectName"}/>
          {isSubmit && !kayitData.projectName &&
              <span className="error">Yetkili adı ve soyadını giriniz.</span>
          }
      </div>

      <div className="btn-container">
          <Btn width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>{getIsLoading ? <SmallSpinner size={"20px"} color={"#E85446"} bgColor={"#fff"}/> : "Kaydet"}</Btn>
          <Btn width="150px" handleClick={() => {dispatch(showModal(null)); dispatch(setSearchCompany(null)); dispatch(setIsSearchCompany(false))}} padding="10px" background="#fff" color={"#E85446"}>Kapat</Btn>
      </div>
    </Container>
  )
}

export default MatchNewProject